<template>
  <div class="training-form">
    <el-form-item label="页数">
      <el-input-number v-model="form.chapterCount" :min="0" :max="9999" style="width: 100%" />
      <div class="form-tip">展示在详情页头部与材料信息中</div>
    </el-form-item>

    <el-form-item label="学习收获">
      <el-input
        v-model="form.learningGoals"
        type="textarea"
        :rows="4"
        placeholder="每行一条，对应详情页「学习收获」列表"
      />
    </el-form-item>

    <el-form-item label="适合人群">
      <el-input
        v-model="form.targetAudience"
        type="textarea"
        :rows="3"
        placeholder="每行一条，对应详情页「适合人群」列表"
      />
    </el-form-item>

    <div class="section-block">
      <div class="section-header">
        <span class="section-title"><i class="el-icon-notebook-2" /> 材料目录</span>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addChapter">添加章节</el-button>
      </div>
      <div v-if="!(form.catalogChapters || []).length" class="section-empty">暂无目录章节，点击右上角添加</div>
      <div v-for="(chapter, index) in (form.catalogChapters || [])" :key="chapter._uid || ('cat-' + index)" class="dynamic-card">
        <div class="card-top">
          <span class="index-badge">{{ index + 1 }}</span>
          <el-button type="text" size="mini" class="danger" @click="removeChapter(index)">删除章节</el-button>
        </div>
        <el-input v-model="chapter.title" placeholder="章节标题（如：认识AI视频工具）" class="field-gap" />
        <div class="lessons-block">
          <div class="lessons-header">
            <span class="field-label">小节列表</span>
            <el-button type="text" size="mini" @click="addLesson(index)">添加小节</el-button>
          </div>
          <div v-if="!(chapter.lessons || []).length" class="section-empty small">暂无小节</div>
          <div
            v-for="(lesson, li) in (chapter.lessons || [])"
            :key="`${chapter._uid || index}-lesson-${li}`"
            class="lesson-row"
          >
            <el-input
              :value="lesson"
              placeholder="小节名称"
              @input="val => updateLesson(index, li, val)"
            />
            <el-button type="text" size="mini" class="danger" @click="removeLesson(index, li)">删除</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-form-item label="材料文件">
      <document-upload
        v-model="form.materialFileUrl"
        biz-type="cms_material"
        @uploaded="handleFileUploaded"
      />
      <div class="form-tip">用户购买后可下载该文件</div>
    </el-form-item>
  </div>
</template>

<script>
import DocumentUpload from '@/components/admin/DocumentUpload.vue'
import { createEmptyCatalogChapter } from '@/utils/materialFormat'

const FORMAT_MAP = {
  pdf: 'PDF',
  doc: 'DOCX',
  docx: 'DOCX',
  ppt: 'PPTX',
  pptx: 'PPTX',
  zip: 'ZIP',
  rar: 'ZIP',
  mp4: 'MP4'
}

export default {
  name: 'TrainingMaterialForm',
  components: { DocumentUpload },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  methods: {
    addChapter() {
      if (!this.form.catalogChapters) {
        this.$set(this.form, 'catalogChapters', [])
      }
      this.form.catalogChapters.push(createEmptyCatalogChapter())
    },
    removeChapter(index) {
      this.form.catalogChapters.splice(index, 1)
    },
    addLesson(chapterIndex) {
      const chapter = this.form.catalogChapters[chapterIndex]
      if (!chapter.lessons) {
        this.$set(chapter, 'lessons', [])
      }
      chapter.lessons.push('')
    },
    updateLesson(chapterIndex, lessonIndex, value) {
      const chapter = this.form.catalogChapters[chapterIndex]
      if (!chapter || !chapter.lessons) return
      this.$set(chapter.lessons, lessonIndex, value)
    },
    removeLesson(chapterIndex, lessonIndex) {
      this.form.catalogChapters[chapterIndex].lessons.splice(lessonIndex, 1)
    },
    handleFileUploaded(file) {
      const name = (file && file.name) || ''
      const ext = name.split('.').pop().toLowerCase()
      const format = FORMAT_MAP[ext]
      if (format) {
        this.form.fileFormat = format
      }
    }
  }
}
</script>

<style scoped>
.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 4px;
}
.section-block {
  margin-bottom: 20px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.section-title {
  font-weight: 600;
  color: #303133;
}
.section-title i {
  margin-right: 6px;
  color: #409eff;
}
.section-empty {
  color: #909399;
  font-size: 13px;
  padding: 8px 0;
}
.section-empty.small {
  padding: 4px 0;
}
.dynamic-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}
.card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.index-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px;
  font-weight: 600;
}
.danger {
  color: #f56c6c;
}
.field-gap {
  margin-bottom: 8px;
}
.lessons-block {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
}
.lessons-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.field-label {
  font-size: 13px;
  color: #606266;
}
.lesson-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.lesson-row .el-input {
  flex: 1;
}
</style>
